
const log = (msg) =>{
    if (window.console && console.log) {
        console.log(msg);
    }
}
const server = ()=> {
    /**
     * http://localhost => http://pc/wp-test
     * http://pc/wp-test => http://pc/wp-test
     * http://192.168.0.107/bas => http://192.168.0.107/bas
     * https://bas.com.ar => https://bas.com.ar
     */
    let server = window.location.origin
    if (server.startsWith('http://localhost') || server.startsWith('http://pc')) {
        server = "http://pc/bas"
    }
    if (server.startsWith("https://192.168.0.107")){
        server = "http://192.168.0.107/bas";
    }
    return server;

}


export {log, server}